function patternMatches(message, pattern) {
    if (typeof pattern === 'string') {
        return message === pattern;
    }
    return pattern.test(message);
}
export function shouldSuppressAnalyticsEvent(message, patterns) {
    if (!patterns?.length) {
        return false;
    }
    return patterns.some((pattern) => patternMatches(message, pattern));
}
//# sourceMappingURL=analyticsNoise.js.map